import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('queues', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`queues/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`queues/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('queue_warehouses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
